export const maquetaTpl = {
  modalDatos: {
    regTitle: `Registration details`,
    paymentMethod: `Payment method`,
    paymentDate: `Payment date`,
    guestCount: `Number of guests`,
    unspecified: `Not specified`,
    pay: {
      DESTI: `Pay at destination`,
      EFECT: `Cash`,
      MOVIL: `Mobile payment`,
      OTRO: `Other payment methods`,
      PLATF: `Payment platform`,
      TARJT: `Credit card`,
      TRANS: `Bank transfer`,
      TREG: `Gift card`,
    },
  },
  whatsapp: {
    title: `Exclusive WhatsApp Business access`,
    body: `To use the WhatsApp Business feature, an active WhatsApp Business Personal subscription is required. This option is designed to give you extra tools and advanced features to boost your business experience.`,
  },
  nav: {
    welcome: `Welcome`,
    manager: `Manager`,
    logout: `Log out`,
    logoutError: `Sorry, an error occurred when logging out`,
  },
  subnav: {
    home: `Home`,
    clients: `Customers`,
    prices: `Prices`,
    payments: `Payments`,
    userManagement: `User management`,
  },
};
